import { ITypedReduxAction } from '../../../types/redux/actionType';
import { IRealtorRatingList } from '../../../types/realtorRatingList';

export enum EGetRealtorRatingActionType {
  Succeed = 'realtorRatingList/getRealtorRatingList/succeed',
  Loading = 'realtorRatingList/getRealtorRatingList/loading',
  Failed = 'realtorRatingList/getRealtorRatingList/failed',
}

export type TGetRealtorRatingListSucceed = ITypedReduxAction<EGetRealtorRatingActionType.Succeed, IRealtorRatingList>;
export type TGetRealtorRatingListLoading = ITypedReduxAction<EGetRealtorRatingActionType.Loading>;
export type TGetRealtorRatingListFailed = ITypedReduxAction<EGetRealtorRatingActionType.Failed>;

export type TGetRealtorRatingList =
  | TGetRealtorRatingListSucceed
  | TGetRealtorRatingListLoading
  | TGetRealtorRatingListFailed;
